<div *ngIf="videoPath">
  <video #videoPlayer autoplay controls></video>
</div>
